<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Job Insight Details</h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="search-cont mt-4 mb-3">
        <div class="s-in form-input" style="position:relative">
            <mat-icon class="input-icon">search</mat-icon>
            <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
                (input)="onSearch($event)" (keyup.enter)="onGo()" />
        </div>
    </div>


    <div class="table-container flex-grow-1">
        <table class="" mat-table [dataSource]="dataSourceJobInsight" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex align-items-center user-profile">
                        <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                        <div class="">
                            <div class="main-head">
                                {{ element.first_name}} {{ element.last_name }}
                            </div>
                            <div class="sub-head">{{ element.email }}</div>
                        </div>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="total_shift">
                <th mat-header-cell *matHeaderCellDef class="data-b">
                    Total Shift
                </th>
                <td mat-cell *matCellDef="let element" class="data-b">
                    {{element.tot_shift}}
                </td>
            </ng-container>
            <ng-container matColumnDef="total_hour">
                <th mat-header-cell *matHeaderCellDef>Total Hour</th>
                <td mat-cell *matCellDef="let element">{{element.tot_hour}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColJobInsight"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColJobInsight"></tr>
        </table>

        <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading">
            <div class="custom-loader"> </div>
        </div>
        <div class="mat-table__message" *ngIf="dataSourceJobInsight.length==0 && !isSpinnerLoading">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
    </div>
    <div class="pagination-cont" *ngIf="dataSourceJobInsight.length!=0">
        <div class="show-item">
            {{ "COMMON.SIP" | translate }}
            <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'user')"
                [(ngModel)]="objData.user.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions">
                    {{ item }}
                </option>
            </select>
        </div>
        <div class="page-c">
            <ngb-pagination [collectionSize]="objData.user.count" [(page)]="objData.user.currentPage"
                [pageSize]="objData.user.itemsPerPage" [maxSize]="objData.user.maxPaginationSize"
                (pageChange)="onPageChange($event, 'user')"></ngb-pagination>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>